<wen-layout>
  <router-outlet></router-outlet>
</wen-layout>
